import React from "react";
import { Element } from "react-scroll";

function About() {
  return (
    <Element
      name="about"
      className="flex text-[#93a2b8] px-4 lg:pt-24"
    >
      <div className="flex flex-col w-full">
        <h1 className="lg:hidden flex text-xl font-WorkSans font-bold pt-16 pb-8 lg:pb-0 ">
          About
        </h1>
        <div className="flex justify-center">
          <img
            className="w-36 mt-8 md:mt-0 border-2 border-black  flex items-center"
            src="/Images/profile.jpeg"
            alt="leander"
          />
        </div>
        <div className="flex flex-col my-4">
          <div className="mb-4">
            <p>I’m a Full stack developer with a strong foundation in building scalable, high-performance web applications using modern JavaScript frameworks and backend technologies. I enjoy working across the stack—crafting responsive, user-focused interfaces while also designing reliable backend systems that scale efficiently.
            </p>
          </div>
          <div className="mb-4">
            <p>Currently, I work at <span className="font-bold">TIAA GBS</span> as a Full Stack Developer, where I develop and test enterprise-grade web applications using Java Spring Boot, Angular, FTL, JavaScript, HTML, and CSS. I actively contribute to improving application reliability and delivery by leveraging CI/CD pipelines with Jenkins and collaborating closely with cross-functional teams.
            </p>
          </div>
          <div className="mb-4">
            <p>I have hands-on experience building real-time and distributed systems, including projects using Node.js, Redis (pub/sub), Kafka, PostgreSQL, Docker, and WebSockets. My work spans social media platforms, real-time chat systems, and peer-to-peer video calling applications, with a strong focus on performance, scalability, and clean architecture. I’m driven by continuous learning and enjoy solving complex engineering problems through practical, production-ready solutions.
            </p>
          </div>
        </div>
      </div>
    </Element>
  );
}

export default About;
